import React, { useState, useEffect } from "react";
import { Outlet } from "react-router-dom";
import { Eye, X, Megaphone } from "lucide-react";
import Sidebar from "./Sidebar";
import Header from "./Header";
import { useAuth } from "@/context/AuthContext";
import api from "@/lib/api";

export default function AppLayout() {
  const [open, setOpen] = useState(false);
  const { user, exitImpersonation } = useAuth();
  const impersonating = user?.impersonated_by;
  const [ann, setAnn] = useState(null);

  useEffect(() => {
    api.get("/announcements").then((r) => {
      const list = r.data || [];
      const dismissed = JSON.parse(localStorage.getItem("pk_dismissed_ann") || "[]");
      const next = list.find((a) => !dismissed.includes(a.id));
      setAnn(next || null);
    }).catch(() => {});
  }, []);

  const dismiss = () => {
    const dismissed = JSON.parse(localStorage.getItem("pk_dismissed_ann") || "[]");
    localStorage.setItem("pk_dismissed_ann", JSON.stringify([...dismissed, ann.id]));
    setAnn(null);
  };

  return (
    <div className="flex h-screen overflow-hidden bg-background">
      <Sidebar open={open} onClose={() => setOpen(false)} />
      <div className="flex-1 flex flex-col overflow-hidden">
        {impersonating && (
          <div className="bg-violet-600 text-white text-sm px-4 py-2 flex items-center justify-between" data-testid="impersonation-banner">
            <div className="flex items-center gap-2"><Eye className="w-4 h-4" /> Viewing as <b>{user.company_name}</b> — admin support session</div>
            <button onClick={exitImpersonation} className="flex items-center gap-1 hover:underline font-medium" data-testid="exit-impersonation"><X className="w-3.5 h-3.5" /> Exit</button>
          </div>
        )}
        {ann && (
          <div className="bg-indigo-50 dark:bg-indigo-500/10 border-b border-indigo-100 dark:border-indigo-500/20 text-sm px-4 py-2 flex items-center justify-between" data-testid="announcement-banner">
            <div className="flex items-center gap-2 text-indigo-700 dark:text-indigo-300 min-w-0"><Megaphone className="w-4 h-4 shrink-0" /><span className="font-medium">{ann.title}</span><span className="text-indigo-500/80 truncate hidden sm:inline">— {ann.content}</span></div>
            <button onClick={dismiss} className="text-indigo-400 hover:text-indigo-700 shrink-0" data-testid="dismiss-announcement"><X className="w-4 h-4" /></button>
          </div>
        )}
        <Header onMenu={() => setOpen(true)} />
        <main className="flex-1 overflow-y-auto p-4 lg:p-6 xl:p-8">
          <div className="animate-fade-up max-w-[1600px] mx-auto w-full">
            <Outlet />
          </div>
        </main>
      </div>
    </div>
  );
}
